import type { Organization } from "@types_def/models/Organization.types";

export default function OrganizationCell({ children }: { children?: Partial<Organization> }) {
  const name = children?.name ?? "Non attribué";
  return <div>{name}</div>;
}
